import { createContext, useContext } from 'react';
import { useCompanyBrandingQuery } from 'src/api/BrandRepository';
import { useSlugContext } from './slugProvider';

type Props = {
  children: React.ReactNode;
};

type LogoCtx = {
  logo_image: string;
};

const Context = createContext<LogoCtx>({} as LogoCtx);

export const LogoProvider: React.FC<Props> = ({ children }) => {
  const { slug_id } = useSlugContext();
  const companyBrand = useCompanyBrandingQuery(slug_id);
  const brand = companyBrand?.data;

  return (
    <Context.Provider value={{ logo_image: brand?.logo_image || '' }}>{children}</Context.Provider>
  );
};

export const useLogoContext = () => {
  const context = useContext(Context);

  return context;
};
